import { Injectable } from '@angular/core';

import { JobInterface } from '@reach/interfaces/jobs/job.interface';
import { GetJobsResponse } from '@reach/interfaces/jobs/jobs.responses';
import { splitInChunks } from '@reach/utils/array/split-in-chunks';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class JobsApiService extends BaseApiService {
	protected commonPath = ['jobs'];

	public async getJobs(ids: string[]): Promise<GetJobsResponse> {
		if (ids.length === 0) {
			return await new Promise((res) => res([]));
		}

		const chunks = [...splitInChunks(ids, 35)];

		const t = this.paramTime;

		const promises = await Promise.allSettled(
			chunks.map(async (chunk) => {
				const params = {
					jobIds: chunk,
					t,
				};
				return await this.http.get<GetJobsResponse>(this.url(), params);
			})
		);

		const jobs: JobInterface[] = [];

		promises.forEach((result) => {
			if (result.status === 'fulfilled') {
				jobs.push(...result.value);
			}
		});

		return jobs;
	}
}
